import { useState } from 'react';
import { useAuth } from '@/state/auth';
import { useChangePassword } from '@/lib/query';

/**
 * 修改密码弹窗。forced=true 时不可关闭(首启强制改密);否则由调用方提供 onClose。
 * 成功后用后端回签的新 token+user 覆盖本地会话,立即解除 mustChangePassword 闸口。
 */
export function ChangePasswordModal({ forced = false, onClose }: { forced?: boolean; onClose?: () => void }) {
  const setUser = useAuth((s) => s.setUser);
  const change = useChangePassword();
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    if (next.length < 8) { setErr('新密码至少 8 位'); return; }
    if (next !== confirm) { setErr('两次输入的新密码不一致'); return; }
    try {
      const res = await change.mutateAsync({ currentPassword: cur, newPassword: next });
      setUser(res.user, res.token);
      onClose?.();
    } catch (ex) {
      setErr((ex as Error)?.message || '修改失败');
    }
  };

  const inp = 'mt-1 w-full rounded-lg border border-hairline px-3 py-2 text-sm outline-none focus:border-brand-400';

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-slate-900/45 p-4">
      <form onSubmit={submit} role="dialog" aria-modal="true" className="card w-[360px] p-6">
        <div className="mb-1 text-[16px] font-bold text-slate-800">{forced ? '首次登录，请先修改密码' : '修改密码'}</div>
        <p className="mb-4 text-[13px] text-slate-500">{forced ? '为保障账号安全，初始口令需在使用前更换。' : '请输入当前账号的密码与新密码。'}</p>
        <label className="mb-3 block text-[13px] text-slate-500">当前密码
          <input type="password" autoComplete="current-password" value={cur} onChange={(e) => setCur(e.target.value)} className={inp} />
        </label>
        <label className="mb-3 block text-[13px] text-slate-500">新密码
          <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className={inp} />
        </label>
        <label className="mb-1 block text-[13px] text-slate-500">确认新密码
          <input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inp} />
        </label>
        {err ? <div className="mt-3 text-[13px] text-alarm-fg">{err}</div> : null}
        <div className="mt-5 flex gap-2">
          <button type="submit" disabled={change.isPending || !cur || !next || !confirm} className="btn btn-primary flex-1 justify-center disabled:opacity-60">
            {change.isPending ? '提交中…' : '确认修改'}
          </button>
          {!forced && onClose ? (
            <button type="button" onClick={onClose} className="btn btn-ghost px-4">取消</button>
          ) : null}
        </div>
      </form>
    </div>
  );
}
